export default {
  error: {
    error_occured: "An error has occurred",
    not_found: "The requested resource was not found.",
    reload_page: "Refresh the page",
    back: "Back",
    message: {
      profile_load_failed: "Unable to load your profile, some information may be hidden. Please refresh the page.",
      not_found: "The page you were looking for was not found!",
      unavailable: "Service not available!",
      not_authorized_title: "Access not authorised",
      not_authorized: "You do not have the required permissions",
      file_not_authorized: "You are not authorized to download a file",
      unauthenticated: "You must be logged in to access this page",
      usurpation_error:
        "You are impersonating an account that does not have access to this area, please stop impersonating this user",
      usurpation_restore_lost: "You have left the impersonated account. Please log in again to recover your session.",
      session_lost: "Your session has expired, please log in again",
    },
    go_back_to_home: "Home",
    support_message:
      "A bug occurred during the operation you attempted to perform. Our teams have been notified and are working to resolve it. Thank you for your understanding.",
    login_attempts:
      "You have {attempts} attempts remaining. After that, your access will be suspended for 5 minutes as a security measure.",
    login_blocked:
      "Your account has been temporarily locked due to several failed login attempts. Please wait 5 minutes before trying again.",
    sso_user_not_found: "No Studea account matches this user. Please contact your administrator.",
    sso_link_expired: "Your sign-in link is no longer valid. Please sign in again from your usual portal.",
  },
  warning: {
    title: "Advertencia : ",
  },
};
